import { ReactNode } from 'react';
import { Button } from '@sweep-io/sweep-design';
import { usePermissions } from '../../../permissions/usePermissions';
import RestrictedTooltip from '../permissions/RestrictedTooltip';
import EmptyState from './EmptyState';
import { ButtonSize } from '@sweep-io/sweep-design/dist/components/Button/types';
import { PermissionQuery } from '../../../permissions/permissions.types';

const EmptyStateWithButton = ({
  image,
  line1,
  line2,
  titleLine,
  onClick,
  permissionQuery,
  notAllowedTitle,
  forceDisallowTitle,
  buttonDisabled,
  buttonSize = 'medium',
  dataTestId,
}: {
  image: ReactNode;
  titleLine?: string;
  line1?: string;
  line2?: string;
  onClick: () => void;
  permissionQuery: PermissionQuery[]
  notAllowedTitle: string;
  forceDisallowTitle?: string;
  buttonDisabled?: boolean;
  buttonSize?: ButtonSize;
  dataTestId?: string;
}) => {
  const { evaluatePermissions } = usePermissions();
  const [isAllowedBtn] = evaluatePermissions(permissionQuery);

  return (
    <EmptyState image={image} line1={line1} line2={line2} titleLine={titleLine}>
      <RestrictedTooltip
        validation={{ type: 'explicit', allowed: isAllowedBtn }}
        notAllowedTitle={notAllowedTitle}
        forceDisallowTitle={forceDisallowTitle}
      >
        <Button
          dataTestId={dataTestId}
          onClick={onClick}
          disabled={!isAllowedBtn || buttonDisabled}
          size={buttonSize ?? 'medium'}
        >
          Get started
        </Button>
      </RestrictedTooltip>
    </EmptyState>
  );
};

export default EmptyStateWithButton;
